import type {
  IConsoleStoreRankPlatform,
  IConsoleStoreRankSource,
  IConsoleStoreRankTop,
  IStoreRankMoreCoreRankUnifiedKey,
  IStoreRankMoreTableDimensionInfos,
} from '@/pages/intelligence/types/storeRank';

export const CONSOLE_UNIFIED_KEY: IStoreRankMoreCoreRankUnifiedKey = 'ed_id';

export const CONSOLE_PLATFORM_PLAYSTATION = 'playstation';
export const WECHAT_PLATFORM_WECHAT = 'weixin';
export const WECHAT_PLATFORM_DOUYIN = 'douyin';
export const CONSOLE_PLATFORM_XBOX = 'xbox';
export const CONSOLE_PLATFORM_NINTENDO = 'nintendo';

export const CONSOLE_PLATFORMS: IConsoleStoreRankPlatform[] = [
  CONSOLE_PLATFORM_PLAYSTATION,
  CONSOLE_PLATFORM_XBOX,
  CONSOLE_PLATFORM_NINTENDO,
];

export const CONSOLE_PLATFORMS_NAMES_MAPPING: {
  [key in IConsoleStoreRankPlatform]: string;
} = {
  [CONSOLE_PLATFORM_PLAYSTATION]: 'PlayStation',
  [CONSOLE_PLATFORM_XBOX]: 'Xbox',
  [CONSOLE_PLATFORM_NINTENDO]: 'Nintendo',
};

export const CONSOLE_TOP_BEST_SELLING: IConsoleStoreRankTop = 'best selling';
export const CONSOLE_TOP_FREE_TO_PLAY: IConsoleStoreRankTop = 'free to play';
export const CONSOLE_TOP_PS5_MOST_DOWNLOADED: IConsoleStoreRankTop = 'ps5 most downloaded';
export const CONSOLE_TOP_PS4_MOST_DOWNLOADED: IConsoleStoreRankTop = 'ps4 most downloaded';
export const CONSOLE_TOP_PS_VR_MOST_DOWNLOADED: IConsoleStoreRankTop = 'ps vr most downloaded';

export const CONSOLE_TOPS: IConsoleStoreRankTop[] = [CONSOLE_TOP_BEST_SELLING];

export const CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING: {
  [key in IConsoleStoreRankTop]: string;
} = {
  'best selling': 'dbi_store_rank_best_selling',
  'most downloaded': 'dbi_store_rank_most_downloaded',
  'new games': 'dbi_store_rank_new_games',
  'coming soon': 'dbi_store_rank_coming_soon',
  'indies games': 'dbi_store_rank_indies_games',
  'free to play': 'dbi_store_rank_free_to_play',
  'ps5 most downloaded': 'dbi_store_rank_ps5_most_downloaded',
  'ps4 most downloaded': 'dbi_store_rank_ps4_most_downloaded',
  'ps vr most downloaded': 'dbi_store_rank_vr_games',
  'new release': 'dbi_store_rank_new_release',
  upcoming: 'dbi_store_rank_upcoming',
  'most played': 'dbi_store_rank_most_played',
  'best sellers': 'dbi_store_rank_best_sellers',
  'best rated': 'dbi_store_rank_best_rated',
  'top free': 'dbi_store_rank_top_free',
  'top paid': 'dbi_store_rank_top_paid',
  // // 'best selling':'dbi_store_rank_best_selling',
  // 'new and rising':'dbi_store_rank_new_and_rising',
  // // 'new release':'dbi_store_rank_new_release',
  // 'most popular':'dbi_store_rank_most_popular',
};

export const CONSOLE_STORE_RANK_TOPS_MAPPING: {
  [key in IConsoleStoreRankPlatform]: IConsoleStoreRankTop[];
} = {
  [CONSOLE_PLATFORM_PLAYSTATION]: [
    'best selling',
    'most downloaded',
    'new games',
    'coming soon',
    'indies games',
    'free to play',
    'ps5 most downloaded',
    'ps4 most downloaded',
    'ps vr most downloaded',
  ],
  [CONSOLE_PLATFORM_XBOX]: [
    'new release',
    'upcoming',
    'most played',
    'best rated',
    'top free',
    'top paid',
  ],
  [CONSOLE_PLATFORM_NINTENDO]: ['best sellers', 'new release', 'coming soon'],
};

export const CONSOLE_SOURCE_PLAYSTATION_BEST_SELLING = 'playstation best selling';

export const CONSOLE_SOURCE_PLAYSTATION_FREE_TO_PLAY = 'playstation free to play';

export const CONSOLE_SOURCE_PLAYSTATION_FREE_TO_PLAY_DAILY =
  CONSOLE_SOURCE_PLAYSTATION_FREE_TO_PLAY;

export const CONSOLE_SOURCE_PLAYSTATION_FREE_TO_PLAY_MONTHLY = 'ps free to play';

export const CONSOLE_SOURCES_PLAYSTATION_MONTHLY_RANK = [
  'ps5 most downloaded',
  'ps4 most downloaded',
  'ps vr most downloaded',
];

export const WECHAT_SOURCES_PLAYSTATION_MONTHLY_RANK = [
  'wechat_popularity',
  'wechat_bestseller',
  'wechat_most_played',
];
export const WECHAT_SOURCES_PLAYSTATION_MONTHLY_RANK_DOUYIN = [
  'douyin_popularity',
  'douyin_bestseller',
  'douyin_fresh_game',
];

export const CONSOLE_SOURCES_PLAYSTATION_DAILY_MONTHLY_RANK = ['playstation free to play'];

export const CONSOLE_SOURCES = [
  CONSOLE_SOURCE_PLAYSTATION_BEST_SELLING,
  'playstation most downloaded',
  'playstation new games',
  'playstation coming soon',
  'playstation indies games',
  'playstation free to play',
  ...CONSOLE_SOURCES_PLAYSTATION_MONTHLY_RANK,
  'xbox most played',
  'xbox new release',
  'xbox upcoming',
  'xbox best rated',
  'xbox top free',
  'xbox top paid',
  'nintendo best sellers',
  'nintendo new release',
  'nintendo coming soon',
];

export const CONSOLE_SOURCES_METRICS_KEYS = [
  'playstation best selling|rank',
  'playstation most downloaded|rank',
  'playstation new games|rank',
  'playstation coming soon|rank',
  'playstation indies games|rank',
  'playstation free to play|rank',
  'ps5 most downloaded|rank',
  'ps4 most downloaded|rank',
  'ps vr most downloaded|rank',
  'xbox most played|rank',
  'xbox new release|rank',
  'xbox upcoming|rank',
  'xbox best rated|rank',
  'xbox top free|rank',
  'xbox top paid|rank',
  'nintendo best sellers|rank',
  'nintendo new release|rank',
  'nintendo coming soon|rank',
];

export const CONSOLE_PLATFORM_TOP_INFOS: {
  [key: string]: IStoreRankMoreTableDimensionInfos;
} = {
  'playstation best selling|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_PLAYSTATION,
    top: 'best selling',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['best selling'],
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'playstation most downloaded|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_PLAYSTATION,
    top: 'most downloaded',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['most downloaded'],
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'playstation new games|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_PLAYSTATION,
    top: 'new games',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['new games'],
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'playstation coming soon|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_PLAYSTATION,
    top: 'coming soon',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['coming soon'],
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'playstation indies games|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_PLAYSTATION,
    top: 'indies games',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['indies games'],
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'playstation free to play|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_PLAYSTATION,
    top: 'free to play',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['free to play'],
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'ps5 most downloaded|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_PLAYSTATION,
    top: 'ps5 most downloaded',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['ps5 most downloaded'],
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'ps4 most downloaded|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_PLAYSTATION,
    top: 'ps4 most downloaded',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['ps4 most downloaded'],
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'ps vr most downloaded|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_PLAYSTATION,
    top: 'ps vr most downloaded',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['ps vr most downloaded'],
    titleContent: '',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'xbox most played|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_XBOX,
    top: 'most played',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['most played'],
    titleContent: 'dbi_store_rank_console_top_title_tips1',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'xbox new release|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_XBOX,
    top: 'new release',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['new release'],
    titleContent: 'dbi_store_rank_console_top_title_tips2',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'xbox upcoming|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_XBOX,
    top: 'upcoming',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING.upcoming,
    titleContent: 'dbi_store_rank_console_top_title_tips3',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'xbox top free|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_XBOX,
    top: 'top free',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['top free'],
    // titleContent: 'dbi_store_rank_console_top_title_tips1',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'xbox best rated|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_XBOX,
    top: 'best rated',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['best rated'],
    // titleContent: 'dbi_store_rank_console_top_title_tips1',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'xbox top paid|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_XBOX,
    top: 'top paid',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['top paid'],
    // titleContent: 'dbi_store_rank_console_top_title_tips1',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'nintendo best sellers|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_NINTENDO,
    top: 'best sellers',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['best sellers'],
    titleContent: 'dbi_store_rank_console_top_title_tips4',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'nintendo new release|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_NINTENDO,
    top: 'new release',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['new release'],
    titleContent: 'dbi_store_rank_console_top_title_tips5',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
  'nintendo coming soon|rank': {
    rendererType: 'TableShowDataRenderer',
    platform: CONSOLE_PLATFORM_NINTENDO,
    top: 'coming soon',
    title: CONSOLE_STORE_RANK_TOPS_NAMES_MAPPING['coming soon'],
    titleContent: 'dbi_store_rank_console_top_title_tips6',
    titleInfo: '',
    ratioShow: true,
    ratioSortable: true,
  },
};

// 月粒度榜单的 地区排名
export const CONSOLE_RANK_METRIC_MONTHLY_SORT_KEYS = ['global', 'us/canada', 'europe'];
// 月粒度榜单的 地区名称
export const CONSOLE_RANK_METRIC_MONTHLY_NAMES_MAPPING: {
  [key: string]: string;
} = {
  global: 'dbi_global',
  'us/canada': 'dbi_area_north_america',
  europe: 'dbi_area_europe',
};

// console榜单下钻页 页面打点配置
export const CONSOLE_PAGE_LOG_CFG_KEYS: { [key: string]: string } = {
  'playstation best selling': 'consoleStoreRankMorePlaystationBestSelling',
  'playstation most downloaded': 'consoleStoreRankMorePlaystationMostDownloaded',
  'playstation new games': 'consoleStoreRankMorePlaystationNewGames',
  'playstation coming soon': 'consoleStoreRankMorePlaystationComingSoon',
  'playstation indies games': 'consoleStoreRankMorePlaystationIndiesGames',
  'playstation free to play': 'consoleStoreRankMorePlaystationFreeToPlay',
  'ps5 most downloaded': 'consoleStoreRankMorePlaystationPS5MostDownloaded',
  'ps4 most downloaded': 'consoleStoreRankMorePlaystationPS4MostDownloaded',
  'ps vr most downloaded': 'consoleStoreRankMorePlaystationVRGames',
  'xbox new release': 'consoleStoreRankMoreXboxNewRelease',
  'xbox upcoming': 'consoleStoreRankMoreXboxUpcoming',
  'xbox most played': 'consoleStoreRankMoreXboxMostPlayed',
  'xbox best rated': 'consoleStoreRankMoreXboxBestRated',
  'xbox top free': 'consoleStoreRankMoreXboxTopFree',
  'xbox top paid': 'consoleStoreRankMoreXboxTopPaid',
  'nintendo best sellers': 'consoleStoreRankMoreNintendoBestSellers',
  'nintendo new release': 'consoleStoreRankMoreNintendoNewRelease',
  'nintendo coming soon': 'consoleStoreRankMoreNintendoComingSoon',
};

export const CONSOLE_SORT_TOPS_KEYS: {
  [key in IConsoleStoreRankPlatform]: IConsoleStoreRankSource[];
} = {
  daily_playstation: [
    'playstation best selling',
    'playstation most downloaded',
    'playstation new games',
    'playstation coming soon',
    'playstation indies games',
    'playstation free to play',
  ],
  monthly_playstation: [
    'ps5 most downloaded',
    'ps4 most downloaded',
    'playstation free to play',
    'ps vr most downloaded',
  ],
  daily_xbox: [
    'xbox most played',
    'xbox new release',
    'xbox upcoming',
    'xbox best rated',
    'xbox top free',
    'xbox top paid',
    //  'xbox best selling',
    //  'xbox new and rising',
    //  'xbox new release',
    //  'xbox most popular',
  ],
  daily_nintendo: ['nintendo best sellers', 'nintendo new release', 'nintendo coming soon'],
};

export const nintendoRegionsOptions = [
  {
    area_code: 'Global',
    area_name_en: 'Global',
    area_name_ch: '全球',
    country_set: [
      {
        country_code: 'global',
        country_name_en: 'Global',
        country_name_ch: '全球',
      },
    ],
  },
  {
    area_code: 'North America',
    area_name_en: 'North America',
    area_name_ch: '北美',
    country_set: [
      {
        country_code: 'us',
        country_name_en: 'United States',
        country_name_ch: '美国',
      },
    ],
  },
  {
    area_code: 'Western Europe',
    area_name_en: 'Western Europe',
    area_name_ch: '西欧',
    country_set: [
      {
        country_code: 'gb',
        country_name_en: 'United Kingdom',
        country_name_ch: '英国',
      },
    ],
  },
];

export const nintendoRegionsOptionsNoGlobal = [
  {
    area_code: 'North America',
    area_name_en: 'North America',
    area_name_ch: '北美',
    country_set: [
      {
        country_code: 'us',
        country_name_en: 'United States',
        country_name_ch: '美国',
      },
    ],
  },
  {
    area_code: 'Western Europe',
    area_name_en: 'Western Europe',
    area_name_ch: '西欧',
    country_set: [
      {
        country_code: 'gb',
        country_name_en: 'United Kingdom',
        country_name_ch: '英国',
      },
    ],
  },
];

export const nintendoUSRegionsOptions = [
  {
    area_code: 'Global',
    area_name_en: 'Global',
    area_name_ch: '全球',
    country_set: [
      {
        country_code: 'global',
        country_name_en: 'Global',
        country_name_ch: '全球',
      },
    ],
  },
  {
    area_code: 'North America',
    area_name_en: 'North America',
    area_name_ch: '北美',
    country_set: [
      {
        country_code: 'us',
        country_name_en: 'United States',
        country_name_ch: '美国',
      },
    ],
  },
];
function getCountryCodes(options) {
  const countryCodes: string[] = [];
  if (!Array.isArray(options)) {
    return [];
  }
  options?.forEach((region) => {
    region?.country_set.forEach((country) => {
      countryCodes.push(country?.country_code);
    });
  });

  return countryCodes;
}

export const nitendoCountryCodes = getCountryCodes(nintendoRegionsOptions);
export const nitendoUSCountryCodes = getCountryCodes(nintendoUSRegionsOptions);
